module.exports = __webpack_public_path__ + "img/choice_tablet.457e0d2d.png";